import React from "react";
import * as PropTypes from "prop-types";
import ScheduleSheet from "./ScheduleSheet";
import {getAdminsWorking, getMastersWorking, loadParlours} from "../../services/organization";
import {
    getParlourTimes,
    getVisitCountGuests,
    getVisits,
    getVisitSnapshots,
    getVisitStatusColor,
    updateVisit,
    visitStatuses
} from "../../services/calendar";
import * as cn from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import _ from "lodash";
import {connect} from "react-redux";
import socketActions from "../../socket/socket-actions";
import Moment from 'moment';
import {extendMoment} from 'moment-range';
import infoActions from "../../components/info/info-actions";
import {
    IconButton,
    Snackbar,
    Tooltip,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CancelIcon from "@material-ui/icons/Cancel";
import {withTranslation} from "react-i18next";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import OnlineIcon from "@material-ui/icons/Public";
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import {equalDates, processMomentFieldInObject} from "../../utils/moment-utils";
import calendarActions from "./calendar-actions";
import {activityTypes} from "../../services/calendarEmployee";
import MoneyIcon from "@material-ui/icons/AttachMoney";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import Face from '@material-ui/icons/Face';
import {paymentStatus} from "../../services/sale";
import {hasRole} from "../../services/user";
import {getMastersAllLoadingByParlourAndDay} from "../../services/moneyFlow";
import HistoryIcon from '@material-ui/icons/History';
import StarIcon from "@material-ui/icons/Star";


const moment = extendMoment(Moment);

export default
@connect(state => ({
    socketMessages: state.socket.messages,
    visits: state.calendar.visits,
    transferredVisits: state.calendar.transferredVisits,
    parlour: state.common.currentParlour,
    hiddenStatuses: state.calendar.hiddenStatuses,
    showTransferredVisits: state.calendar.showTransferredVisits,
}),{
    removeMessages: socketActions.removeMessages,
    showError: infoActions.showError,
    showInfo: infoActions.show,
    setVisits: calendarActions.setVisits,
    setTransferredVisits: calendarActions.setTransferredVisits,
    setShowTransferredVisits: calendarActions.setShowTransferredVisits,
})
@withStyles(theme => ({
    event: {
        padding: '2px 3px',
        border: '1px solid #888',
        cursor: 'pointer',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        lineHeight: 1.1,

        '@media print': {
            borderColor: '#000',
        }
    },
    eventWithColorFacilityLine: {
        paddingLeft: 20,
    },
    facilityLine: {
        width: 7,
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    eventHasLinkedVisits: {
        '@media screen': {
            //boxShadow: 'inset 0px 0px 5px 2px rgba(122,95,42,1)',
            borderColor: 'blue',
            borderWidth: 2,
        }
    },
    eventCurrent: {
        borderColor: '#333',
        borderWidth: 2,
    },
    eventLabelTime: {
        fontSize: '0.7rem',
        fontWeight: 'bold',
    },
    eventLabel: {
        fontSize: '0.7rem',
    },
    eventIcons: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    eventIcon: {
        fontSize: '13px',
    },
    starIcon: {
        fontSize: '13px',
        color: '#f00'
    },
    masterRating: {
        fontSize: '13px',
        position: 'absolute',
        top: 0,
        textAlign: 'center',
        width: '100%',
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        marginTop: 2
    },
    masterRatingStar: {
        fontSize: 15,
        color: '#FFC839'
    },
    loadDuration: {
        fontSize: '13px',
        position: 'absolute',
        bottom: 0,
        textAlign: 'center',
        width: '100%',
        left: 0,
        display: 'flex',
        justifyContent: 'space-around'
    },
    loadDurationUnfree: {
        color: '#6f88df',
        transform: 'translateY(-32px);'
    },
    loadDurationFree: {
        color: '#890015',
        transform: 'translateY(-32px);'
    },
    hidePrint: {
        '@media print': {
            display: 'none',
        },
    },
    showPrint: {
        display: 'none',
        '@media print': {
            display: 'block',
        }
    },
    markPair: {
        '@media screen': {
            borderRadius: '50%',
            left: '50%',
            top: '50%',
            position: 'absolute',
            width: 10,
            height: 10,
            background: 'red',
            border: '1px solid black',
        }
    },
    eventStriped: {
        backgroundImage: 'url(/img/striped-red.png)',
    },
    roomComment: {
        position: 'absolute',
        right: -1,
        bottom: -1,
        fontSize: 12,
        fontWeight: 500,
        color: '#fff',
        border: '1px solid black',
        padding: '1px 2px',
    },
    headerTogether: {
        backgroundColor: theme.palette.background.default,
        paddingTop: 18,
        left: 0,
        top: 0,
        position:'absolute',
    }
}))
@withTranslation()
class ScheduleVisitsRooms extends React.PureComponent
{
    static propTypes = {
        date: PropTypes.instanceOf(moment).isRequired,

        reloadVisits: PropTypes.bool,
        reloadMasters: PropTypes.bool,

        onSlotClick: PropTypes.func,
        onSlotDbClick: PropTypes.func,
        onSlotContextMenu: PropTypes.func,

        selectedVisit: PropTypes.object,

        onVisitClick: PropTypes.func,
        onVisitDbClick: PropTypes.func,
        onVisitContextMenu: PropTypes.func,

        onHeaderClick: PropTypes.func,

        setHeaderData: PropTypes.func,
        setMasters: PropTypes.func,
    };

    static defaultProps = {
        reloadVisits: false,
        reloadMasters: false,
    };

    constructor(props) {
        super(props);

        const visitMessages = props.socketMessages.filter(message => message.entity === 'visit');
        if (visitMessages.length) {
            props.removeMessages(visitMessages.map(message => message.id));
        }


        this.state = {
            masters: [],
            rooms: [],
            loadParlours: [],
            сolumns: [],

            startTime: moment.duration("00:00"),
            endTime: moment.duration("23:59"),
            relaxTime: 15,

            reloadVisits: false,
            reloadMasters: false,

            draggingIdx: -1,
            ctrlPressed: false,

            equipments: [],
            lines: [],
            adminSlots: [],
            mastersLoadData: {},

            guestsVisitCount: {},

            currentView: 'masters',
        };

        this.roomsMap = {};
        this.equipmentsMap = {};
        this.bufferColumn = -1;
    }

    componentDidMount() {

        this.setParlourTimes(this.props.parlour, this.props.date)
            .then(() => {
                this.loadMasters(this.props);
                this.loadVisits(this.props);
                this.loadSnapshots(this.props)
                this.setLines(this.props);
                this.loadGuestsVisitCount(this.props);
            });

        this.loadParlours(this.props.parlour, this.props.date)

        this.getMastersLoadData();


        document.addEventListener('keydown', this.handleKeyboardEvent);
        document.addEventListener('keyup', this.handleKeyboardEvent);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyboardEvent);
        document.removeEventListener('keyup', this.handleKeyboardEvent);
    }

    handleKeyboardEvent = event => {
        if (event.key === 'Control') {
            this.setState({
                ctrlPressed: event.type === 'keydown',
            });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.parlour !== prevProps.parlour ||
            !equalDates(this.props.date, prevProps.date)
        ) {
            this.setParlourTimes(this.props.parlour, this.props.date)
                .then(() => {
                    this.loadMasters(this.props);
                    this.loadVisits(this.props);
                    this.loadSnapshots(this.props);
                    this.loadGuestsVisitCount(this.props);
                });
            this.loadParlours(this.props.parlour, this.props.date)
        }

        if (this.props.parlour !== prevProps.parlour) {
            this.setLines(this.props);
        }

        if (this.props.reloadVisits !== prevProps.reloadVisits) {
            this.loadVisits(this.props);
            this.loadSnapshots(this.props);
            this.loadGuestsVisitCount(this.props);
        }

        if (this.props.reloadMasters !== prevProps.reloadMasters) {
            this.loadMasters(this.props);
        }

        if (this.props.socketMessages !== prevProps.socketMessages) {
            let processedIds = [];
            let visits = [];
            let removeVisits = [];

            this.props.socketMessages.forEach(message => {
                if (message.entity && message.entity === 'visit') {
                    processedIds.push(message.id);
                    if (message.action === 'remove') {
                        removeVisits.push(message.entityId);
                    } else if (message.entityData) {
                        visits.push(message.entityData);
                    }
                }
            });

            visits = this.processingVisit(visits.filter(visit => visit.parlour && prevProps.parlour && visit.parlour.id === prevProps.parlour.id));
            const visitsFilter = this.getVisitsFilter(prevProps);
            visits = visits.filter(visit => visit.start && visit.start.isBetween(visitsFilter.fromDate, visitsFilter.toDate, 'minute', '[]'));

            let draggingIdx = prevState.draggingIdx;
            let draggingVisitId = draggingIdx >= 0 ? prevProps.visits[draggingIdx].id : null;

            if (draggingVisitId) {
                if (visits.findIndex(newVisit => newVisit.id === draggingVisitId) >= 0 || removeVisits.indexOf(draggingVisitId) >= 0) {
                    draggingIdx = -1;
                    draggingVisitId = null;
                }
            }

            if (visits.length || removeVisits.length) {
                const oldFilteredVisits = prevProps.visits.filter(oldVisit => visits.findIndex(newVisit => newVisit.id === oldVisit.id) === -1 && removeVisits.indexOf(oldVisit.id) === -1);

                if (draggingVisitId) {
                    draggingIdx = oldFilteredVisits.findIndex(oldVisit => oldVisit.id === draggingVisitId);
                }

                this.props.setVisits(this.processingRooms([
                    ...oldFilteredVisits,
                    ...visits,
                ]));

                this.setState({
                    draggingIdx,
                });

                this.getMastersLoadData();
            }

            if (processedIds.length) {
                this.props.removeMessages(processedIds);
            }
        }
    }

    getMastersLoadData = () => {
        const { startTime } = this.state;
        getMastersAllLoadingByParlourAndDay({
            'day': this.props.date.clone().startOf('day').add(startTime).toISOString(),
            'parlourId': this.props.parlour.id
        })
            .then(response => {
                if (response.success) {
                    this.setState({
                        mastersLoadData: response.data,
                    });
                } else {
                    this.setState({
                        mastersLoadData: {},
                    });
                }
            });
    }

    loadParlours(parlour, date) {
        if (parlour) {
            const columns = parlour?.rooms || [];
            const columnsWithVisits = [];

            columns.forEach(room => {
                    for (let i = 1; i <= room.count; i++) {
                        const columnValue = `${room.id}-${i}`;
                        columnsWithVisits.push({
                            label: room.name,
                            value: room.id,
                            index: `${i}`,
                            count: room.count,
                        });
                        this.roomsMap[columnValue] = columnsWithVisits.length - 1;
                    }
            });

            this.setState({ columns: columnsWithVisits });
        }

        if (hasRole('ROLE_CALLCENTER_TIMESEARCH')) {
            loadParlours(processMomentFieldInObject({
                dateFrom: date,
                dateTo: date.clone().endOf('day'),
                businessUnitIds: [parlour.id]
            }, ['dateFrom', 'dateTo']), 1, -1, 'asc', 'date_field')
                .then(response => {
                    if (response.success) {
                        this.setState({
                            loadParlours: response.data,
                        });
                    }
                });
        }
    }

    getVisitsFilter = (props) => {
        const { startTime, endTime } = this.state;
            return {
                parlour: props.parlour ? props.parlour.id : null,
                fromDate: props.date.clone().startOf('day').add(startTime).toISOString(),
                toDate: props.date.clone().startOf('day').add(endTime).toISOString(),
            };
    };

    setLines = props => {
        if (props.parlour && props.parlour.id) {
            let lines = props.parlour.scheduleLines.map(line => {
                let time = moment(line.time).utcOffset(props.parlour.timeZone);
                return {
                    time: time,
                    color: line.color
                };
            });
            this.setState({
                lines: lines
            })
        }
    };

    loadMasters = props => {
        if (props.parlour && props.parlour.id) {
            getMastersWorking(this.getVisitsFilter(props) )
                .then(response => {
                    if (response.success) {
                        const masters = response.data;

                        this.mastersMap = {};
                        masters.forEach((master, masterIdx) => {
                            this.mastersMap[master.id] = masterIdx;
                            master.enabledSlots = [];
                            master.enabledColumns = [];
                            master.disabledSlots = [];
                            master.waiting = [];
                            if (master.workShift && Array.isArray(master.workShift)) {
                                master.workShift.forEach(workShift => {
                                    const start = moment(workShift.timeStart).utcOffset(props.parlour.timeZone).seconds(0);
                                    const end = moment(workShift.timeEnd).utcOffset(props.parlour.timeZone).seconds(0);
                                    if (props.date.isSame(start, 'day')) {
                                        if (workShift.parlour.id === props.parlour.id &&  workShift.activity === activityTypes.waiting) {
                                            master.waiting.push({
                                                day: props.date,
                                            });
                                        }

                                        if (workShift.parlour.id === props.parlour.id && (workShift.activity === activityTypes.working || workShift.activity === activityTypes.waiting)) {
                                            master.enabledSlots.push({
                                                day: props.date,
                                                start,
                                                end,
                                                startDuration: start.diff(props.date),
                                                endDuration: end.diff(props.date),
                                            });
                                        } else if (workShift.parlour.id === props.parlour.id && workShift.activity === activityTypes.overtime ) {
                                            master.enabledSlots.push({
                                                day: props.date,
                                                start,
                                                end,
                                                startDuration: start.diff(props.date),
                                                endDuration: end.diff(props.date),
                                            });
                                        } else {
                                            master.disabledSlots.push({
                                                day: props.date,
                                                start,
                                                end,
                                                startDuration: start.diff(props.date),
                                                endDuration: end.diff(props.date),
                                                parlour: workShift.parlour,
                                                activity: workShift.activity,
                                                comment: workShift.comment,
                                            });
                                        }
                                    }
                                });

                                if (master.enabledSlots.length) {
                                    master.enabledColumns.push(props.date);
                                }
                            }

                        });
                        this.setState({
                            masters,
                        }, () => {
                            this.props.setMasters && this.props.setMasters(masters);
                            this.getMastersLoadData();
                        });

                    }
                });

            getAdminsWorking(this.getVisitsFilter(props) )
                .then(response => {
                    if (response.success) {
                        const adminSlots = [];
                        response.data.forEach(admin => {
                            if (admin.workShift && Array.isArray(admin.workShift)) {
                                admin.workShift.forEach(workShift => {
                                    const start = moment(workShift.timeStart).utcOffset(props.parlour.timeZone).seconds(0);
                                    const end = moment(workShift.timeEnd).utcOffset(props.parlour.timeZone).seconds(0);
                                    if (props.date.isSame(start, 'day')) {

                                        if (workShift.parlour.id === props.parlour.id && (workShift.activity === activityTypes.working || workShift.activity === activityTypes.overtime)) {
                                            adminSlots.push({
                                                day: props.date,
                                                start,
                                                end,
                                                startDuration: start.diff(props.date),
                                                endDuration: end.diff(props.date),
                                            });
                                        }
                                    }
                                });
                            }
                        });
                        this.setState({
                            adminSlots,
                        });
                    }
                });
        } else {
            this.setState({
                adminSlots: [],
            })
        }
    };

    loadVisits = (props) => {
        if (props.parlour && props.parlour.id) {
            this.props.setVisits([]);

            this.setState({
                draggingIdx: -1,
            });
            getVisits(this.getVisitsFilter(props))
                .then(response => {
                    if (response.success) {
                        if (response.data.length && response.data[0].parlour && response.data[0].parlour.id === this.props.parlour.id) {

                            this.props.setVisits(this.processingRooms(this.processingVisit(response.data)));
                            this.setState({
                                draggingIdx: -1,
                            });
                        }
                    }
                });
        } else {
            this.props.setVisits([]);
            this.setState({
                draggingIdx: -1,
            });
        }
    };

    loadSnapshots(props) {
        this.props.setTransferredVisits([]);
        getVisitSnapshots(this.getVisitsFilter(props))
            .then(response => {
                if (response.success) {
                    if (response.data.length && response.data[0].parlour && response.data[0].parlour.id === this.props.parlour.id) {
                        this.props.setTransferredVisits(this.processingVisit(response.data));
                        if(this.props.showTransferredVisits) {
                            this.props.setShowTransferredVisits(true)
                        }
                    }
                }
            })
    }

    loadGuestsVisitCount(props) {
        const { startTime } = this.state;
        let day = props.date.clone().startOf('day').add(startTime).format('YYYY-MM-DD');
        let businessUnitId = props.parlour.id;
        getVisitCountGuests(day, businessUnitId)
            .then(response => {
                if (response.success) {
                    this.setState({
                        guestsVisitCount: response.data,
                    });
                }
            });
    }

    processingRooms(visits) {
        const { columns } = this.state;

        const processedVisits = [];
        const roomNumber = {};

        columns.forEach(column => {
            if (column.value.length >= 1) {
                const value = column.value;
                if (!roomNumber[value]) {
                    roomNumber[value] = column.index;
                }
            }
        });

        visits.forEach(visit => {
            if (!visit.index) {
                const visitRange = moment.range(visit.start, visit.end);

                const overlappingVisits = visits.filter(otherVisit => {
                    if (otherVisit === visit) {
                        return false;
                    }
                    const otherRange = moment.range(otherVisit.start, otherVisit.end);
                    return (
                        visit.roomId === otherVisit.roomId && visitRange.overlaps(otherRange)
                    );
                });

                const overlappingVisitsWithIndex = overlappingVisits.filter(v => v.index);
                let roomColumnIndex = roomNumber[visit.roomId];
                if (overlappingVisitsWithIndex.length > 0) {
                    roomColumnIndex = Math.max(...overlappingVisitsWithIndex.map(v => v.index)) + 1;
                } else {
                    const lastOverlappingVisit = overlappingVisits[overlappingVisits.length - 1];
                    if (lastOverlappingVisit) {
                        const lastOverlappingVisitColumnIndex = processedVisits.find(
                            v => v.id === lastOverlappingVisit.id
                        )?.index;

                        if (lastOverlappingVisitColumnIndex) {
                            roomColumnIndex = lastOverlappingVisitColumnIndex + 1;
                        } else {
                            roomColumnIndex = 1;
                        }
                    }
                }

                const canceledIndex = visits.find(v => v.roomId === visit.roomId && v.status === visitStatuses.canceled && v.id !== visit.id)?.index;

                visit.index = canceledIndex ?? roomColumnIndex;
                processedVisits.push({ id: visit.id, roomColumnIndex });
            }
        });

        return visits;
    }

    processingVisit(visits) {
        const { parlour } = this.props;

        visits.forEach(visit => {
            visit.visitFacility.forEach(vf => {
                vf.start = moment(vf.start).utcOffset(parlour.timeZone);
                vf.startDay = vf.start.clone().startOf('day');
                vf.duration = moment.duration(vf.duration, 'minutes');
                vf.end = vf.start.clone().add(vf.duration);

                if (!visit.start || vf.start < visit.start) {
                    visit.start = vf.start.clone();
                }

                if (!visit.end || vf.end > visit.end) {
                    visit.end = vf.end.clone();
                }
            });
        });

    return visits;
    }

    setParlourTimes(parlour, date) {
        return new Promise(resolve => {
            this.setState(getParlourTimes(parlour, date), () => { resolve(); });
        })

    }

    isVisitBop(visit) {
        return !!(visit.sale?.payments ?? []).find((payment) => {
            return payment.payDocTypeCode && payment.payDocTypeCode === 'БОП';
        });
    }

    isPairWithSelected(visit) {
        const { selectedVisit } = this.props;

        if (selectedVisit) {
            return visit.parentId === selectedVisit.id
                || visit.id       === selectedVisit.parentId
                || (selectedVisit.hasChildren && selectedVisit.id === visit.id)
                || (visit.parentId && selectedVisit.parentId && visit.parentId === selectedVisit.parentId);
        }

        return false;
    }

    renderVisitDay = (visit, eventIdx, columns, timeSlots, timeStep, isOldVisit = false) => {
        const { classes, selectedVisit, onVisitClick, onVisitDbClick, onVisitContextMenu, hiddenStatuses, date } = this.props;
        const { draggingIdx, ctrlPressed, guestsVisitCount } = this.state;


        let elements = [];

        if (hiddenStatuses && hiddenStatuses.indexOf(visit.status) >= 0) {
            return elements;
        }
        let isCash = false;
        let isCashless = false;
        let isPaymentProcessing = false;
        if (visit.sale && visit.sale.payments && visit.sale.payments.length) {
            visit.sale.payments.forEach(payment => {
                if (payment.type === 'cash') {
                    isCash = true;
                } else if (payment.type === 'cashless' && payment.status !== paymentStatus.processing) {
                    isCashless = true;
                }
                if (payment.status === paymentStatus.processing) {
                    isPaymentProcessing = true;
                }
            });
        }

        let firstTime = false;
        if (visit.guest && visit.guest.id) {
            firstTime = guestsVisitCount && guestsVisitCount[visit.guest.id] === 0;
            visit.guestPastVisitsCount = guestsVisitCount[visit.guest.id]; // чото не очень как то тут втыкать наверное
        }

        const dayStart = date.clone().startOf('day');

        const columnId = this.roomsMap[`${visit.roomId}-${visit.index || 1}`];

        const columnIdx = columnId === undefined ? columns.length : columnId;

        let disabledColumns = [];
        for (let i = 0; i < columns.length; i++) {
            if (columns[i].value === visit.roomId && i !== columnIdx && columns[i].index === visit.index) {
                disabledColumns.push(i);
            }
        }

        visit.visitFacility.forEach((vf, vfIdx) => {
            const color = (vf.facility && vf.facility.color) || 'transparent';
            let masterName = '';
            if (visit){
                masterName = vf.master.map(master => master.name).join(', ');
            }

            elements.push({
                slotIdx: timeSlots.findIndex(slot => vf.start.clone().subtract(slot).diff(dayStart) < timeStep),
                columnIdx,
                height: vf.duration.asMinutes() / timeStep.asMinutes(),
                ids: [eventIdx, vfIdx, columnIdx],
                element:
                    <div
                        key={`${vf.id}`}
                        className={cn(classes.event, {
                            [classes.eventHasLinkedVisits]: (visit.parentId || visit.hasChildren),
                            [classes.eventCurrent]: (selectedVisit && visit.id === selectedVisit.id),
                            [classes.eventStriped]: visit.hasWaitingMasters,
                            [classes.eventWithColorFacilityLine]: !!(vf.facility && vf.facility.color)
                        })}
                        style={{
                            borderColor: !isOldVisit && draggingIdx === eventIdx ? '#000000' : null,
                            borderWidth: !isOldVisit && draggingIdx === eventIdx ? 2 : null,
                        }}
                        onClick={e => onVisitClick && onVisitClick(visit, e)}
                        onDoubleClick={e => onVisitDbClick && onVisitDbClick(visit, e)}
                        onContextMenu={e => !e.altKey && onVisitContextMenu && onVisitContextMenu(visit, e)}
                    >
                        <div className={classes.facilityLine} style={{backgroundColor: color}}/>
                        <div
                            className={cn(classes.eventLabelTime, classes.hidePrint)}
                        >{vf.start.format('HH:mm')} - {vf.end.format('HH:mm')}{visit.isRB ? <small> РБ</small> : null}{
                            columnIdx === columns.length ?
                                <span> {visit.roomName}</span>
                                : null
                        }</div>
                        {visit.status === visitStatuses.new ?
                            <div className={classes.eventLabel}>
                                {visit.creator.username}<br/>
                                {visit.creator.phone}
                            </div>
                            :
                            <div className={classes.eventLabel}>
                                <div className={classes.showPrint}>
                                    {vf.facility ? <div>{visit.guest && visit.guest.genderPrint ? visit.guest.genderPrint : <span>&nbsp;&nbsp;&nbsp;</span>} {vf.facility.code} - {vf.duration.asHours()}h</div> : null}
                                    {visit.guest ? <div>{visit.guest.name}</div> : <div><i>Инкогнито</i></div>}
                                </div>
                                <div className={classes.hidePrint}>
                                    {visit.guest ? <div>{visit.guest.fullName}<br/>{visit.guest.phone}</div> : <div><i>Инкогнито</i></div>}
                                    {vf.facility ? <div>{vf.facility.code}-{vf.facility.name}</div> : null}
                                </div>
                            </div>
                        }
                        <div className={classes.eventIcons}>
                            {firstTime ? <Tooltip title="First time guest"><StarIcon className={classes.starIcon}/></Tooltip> : null}
                            {isCash ? <Tooltip title="Cash"><MoneyIcon className={classes.eventIcon}/></Tooltip> : null}
                            {isCashless ? <Tooltip title="Credit card"><CreditCardIcon className={classes.eventIcon}/></Tooltip> : null}
                            {isPaymentProcessing ? <Tooltip title="Have processing payment(s)"><HourglassEmptyIcon className={classes.eventIcon}/></Tooltip> : null}
                            {visit.guest && visit.guest.isClubMember ? <Tooltip title="Club member"><Face className={classes.eventIcon}/></Tooltip> : null}
                            {visit.isOnline ? <Tooltip title="Online"><OnlineIcon className={classes.eventIcon}/></Tooltip> : null }
                            {this.isVisitBop(visit) ? <Tooltip title="БОП"><PriorityHigh className={classes.eventIcon}/></Tooltip> : null }
                            {visit.isTransferred ? <Tooltip title="Snapshot"><HistoryIcon className={classes.eventIcon}/></Tooltip> : null }
                        </div>
                        { this.isPairWithSelected(visit) ?
                            <div className={classes.markPair}> </div>
                        : null}
                        { masterName ? <div className={classes.roomComment}>{masterName}</div> : null }
                    </div>,
                elementStyle: {
                    background: getVisitStatusColor(visit.status),
                    zIndex: !ctrlPressed && (visit.status === visitStatuses.canceled || visit.status === visitStatuses.blocked || isOldVisit || visit.isTransferred) ? 0 : '',
                    opacity: isOldVisit  ? 0.3 : (!ctrlPressed && (visit.status === visitStatuses.canceled || visit.status === visitStatuses.blocked || visit.isTransferred) ? 0.5 : null),
                },
                disabledDragColumns: disabledColumns,
                disabledDragSlots: [],
                canDrag: visit.isTransferred ? false :
                    !isOldVisit && [visitStatuses.created, visitStatuses.confirmed, visitStatuses.risky, visitStatuses.starting, visitStatuses.providing].indexOf(visit.status) >= 0
                    && (draggingIdx < 0 || draggingIdx === eventIdx),
            });
        });

        if (visit.oldVisit) {
            elements = elements.concat(this.renderVisitDay(visit.oldVisit, eventIdx, columns, timeSlots, timeStep, true));
        }

        return elements;
    };

    handleSlotDropHover = (slot, column, event, ids) => {
        const { date } = this.props;
        const dayStart = date.clone().startOf('day');

        const [visitIdx, vfIdx] = ids;
        const vf = event.visitFacility[vfIdx];
        const newStart = dayStart.clone().add(slot);
        const diffStart = newStart.isSame(vf.start) ? null : newStart.diff(vf.start);
        let changed = false;
        if ((column.value !== event.roomId) || (column.index !== event.index)) {

            event.roomId = column.value;
            event.index = column.index;
            changed = true;
        }

        if (changed || diffStart) {
            let { visits } = this.props;

            if (changed) {
                visits[visitIdx].visitFacility[vfIdx] = vf;
            }

            if (diffStart) {
                visits[visitIdx].visitFacility.forEach(vf => { vf.start.add(diffStart); vf.end.add(diffStart); vf.startDay = vf.start.clone().startOf('day'); });
                visits[visitIdx].start.add(diffStart);
                visits[visitIdx].end.add(diffStart);
            }

            this.props.setVisits(this.processingRooms([...visits]));
        }
    };

    handleSlotDropHoverDebounce = _.debounce(this.handleSlotDropHover, 50);

    handleBeginDrag = (visit, [visitIdx]) => {
        let { draggingIdx } = this.state;
        let { visits } = this.props;

        if (draggingIdx < 0 && !visits[visitIdx].oldVisit) {
            visits[visitIdx].oldVisit = _.cloneDeep(visits[visitIdx]);

            this.props.setVisits(this.processingRooms([...visits]));
            this.setState({
                draggingIdx: visitIdx
            });
        }
    };

    handleAcceptDrag = () => {
        let { draggingIdx } = this.state;
        let { visits } = this.props;

        if (draggingIdx >= 0) {
            this.setState({
                draggingIdx: -1
            });

            updateVisit(visits[draggingIdx])
                .then(response => {
                    if (response.success) {
                        const newVisit = this.processingVisit([response.data])[0];

                        this.props.setVisits(this.processingRooms([
                            ...this.props.visits.filter(oldVisit => oldVisit.id !== newVisit.id),
                            newVisit,
                        ]));
                        this.loadSnapshots(this.props)
                        this.props.showInfo('Изменения успешно сохранены');
                    } else {
                        this.props.showError(response.error ? response.error.message : response.message);
                        this.loadVisits(this.props);
                        this.loadSnapshots(this.props);
                        this.loadGuestsVisitCount(this.props);
                    }
                })
        }
    };

    handleDeclineDrag = () => {
        let { draggingIdx } = this.state;
        let { visits } = this.props;

        if (draggingIdx >= 0) {
            visits[draggingIdx] = visits[draggingIdx].oldVisit;

            this.props.setVisits([...visits]);
            this.setState({
                draggingIdx: -1
            });
        }
    };

    renderColumnTitle = (column) => {
        const {classes} = this.props;

        if (column.count > 1) {
            return <>
                {column.index === '1' && <span className={classes.headerTogether} style={{width: 150 * column.count}}>{column.label}</span>}
                <br/>
                <span>{column.index}</span>
            </>;
        } else {
            return <>
                <span>{column.label}</span>
            </>
        }
    }

    handleSlotClick = (column, slot, event) => {
        const { onSlotClick, date } = this.props;
        if (onSlotClick) {
            onSlotClick(date.clone().startOf("day").add(slot), column, event);
        }
    }

    handleSlotDbClick = (column, slot, event) => {
        const { onSlotDbClick, date } = this.props;

            if (onSlotDbClick) {
                onSlotDbClick(date.clone().startOf("day").add(slot), column, event);
            }
    }

    handleSlotContextMenu = (column, slot, event) => {
        const { onSlotContextMenu, date } = this.props;
        if (onSlotContextMenu) {
            onSlotContextMenu(date.clone().startOf("day").add(slot), column, event);
        }
    }

    getColumnStyle = column =>
        column.lineColor ? {background: column.lineColor} :
            column.type === 'barrel' ?
                {background: '#ded166'}
                :
                column.type === 'room' ?
                    {background: '#73cba7'}
                    :
                    (column.waiting && column.waiting.length) ?
                        {background: '#fff200'}
                        :
                        {}

    render() {
        const { date, onHeaderClick, t, parlour, visits } = this.props;
        const { startTime, endTime, draggingIdx, lines, adminSlots, mastersLoadData, rooms, columns } = this.state;

        rooms.forEach(parlour => {
            let masterDuration = 0;
            let masterDurationFree = 0;

            if (mastersLoadData[parlour.roomId]) {
                masterDuration = mastersLoadData[parlour.roomId].totalDuration * 60;
                masterDurationFree = mastersLoadData[parlour.roomId].free * 60;
            } else {
                // Если данных нет, то посчитаем по визитам (хотя бы что-то выведется)
                visits.forEach(visit => {
                    if (visit.status === visitStatuses.canceled || visit.status === visitStatuses.blocked) {
                        return true;
                    }
                    visit.visitFacility.filter(vf =>vf.facility && !vf.facility.notCountForMasters).forEach(vf => {
                        if (vf.parlour.findIndex(item => item.id === parlour.roomId) >= 0) {
                            const duration = moment.isDuration(vf.duration) ? vf.duration.asMinutes() : vf.duration;
                            masterDuration += duration;
                            if (!vf.price) {
                                masterDurationFree += duration;
                            }
                        }
                    });
                });
            }
            const masterDurationUnfree = masterDuration - masterDurationFree;

            parlour.loadDuration = masterDuration;
            parlour.loadDurationFree = masterDurationFree;
            parlour.loadDurationUnfree = masterDurationUnfree;
        });

        return <React.Fragment>
            <ScheduleSheet
                printInfo={date.format('DD.MM YYYY')}
                timeZone={parlour ? parlour.timeZone : "+04:00"}
                lines={lines}
                showCurrentTime={date.diff(moment().startOf('day'), 'days') === 0}
                startDayTime={startTime}
                endDayTime={endTime}
                columns={columns}
                columnTitle={this.renderColumnTitle}
                columnWidth={150}
                columnStyle={this.getColumnStyle}
                onSlotClick={this.handleSlotClick}
                onSlotDbClick={this.handleSlotDbClick}
                onSlotDropHover={this.handleSlotDropHoverDebounce}
                events={[...visits]}
                onSlotContextMenu={this.handleSlotContextMenu}
                renderEvent={this.renderVisitDay}
                onHeaderClick={onHeaderClick}
                onBeginDrag={this.handleBeginDrag}
                markAdminGapSlots={parlour?.showAdminGaps || adminSlots}
            />
            <Snackbar
                open={draggingIdx >= 0}
                color=""
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                message={<span>{t("Transfer of the visit Are you sure")}</span>}
                action={[
                    <IconButton
                        key="accept-drag"
                        onClick={this.handleAcceptDrag}
                        color="inherit"
                    >
                        <CheckIcon />
                    </IconButton>,
                    <IconButton
                        key="cancel-drag"
                        onClick={this.handleDeclineDrag}
                        color="inherit"
                    >
                        <CancelIcon />
                    </IconButton>,
                ]}
            />
        </React.Fragment>
    }
}
